import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ALL_PROGRAMS_OPTION, PROGRAM_OPTIONS } from '../components/dashboard/constants';

const DEFAULT_PAGE_SIZE = 100;

export const useCancelsReport = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [programName, setProgramName] = useState(ALL_PROGRAMS_OPTION);
  const [source, setSource] = useState('all');
  const [includeAppsheet, setIncludeAppsheet] = useState(true);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: DEFAULT_PAGE_SIZE });

  const cancelProgramParam = searchParams.get('cancelProgram');

  useEffect(() => {
    if (!cancelProgramParam) {
      if (programName !== ALL_PROGRAMS_OPTION) {
        setProgramName(ALL_PROGRAMS_OPTION);
        setPagination((prev) => ({ ...prev, pageIndex: 0 }));
      }
      return;
    }
    const nextProgram = cancelProgramParam.trim();
    if (!nextProgram || nextProgram === programName) return;
    if (!PROGRAM_OPTIONS.includes(nextProgram)) return;
    setProgramName(nextProgram);
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
  }, [cancelProgramParam, programName]);

  const updateProgramParam = (nextProgram) => {
    const params = new URLSearchParams(searchParams);
    if (nextProgram && nextProgram !== ALL_PROGRAMS_OPTION) {
      params.set('cancelProgram', nextProgram);
    } else {
      params.delete('cancelProgram');
    }
    setSearchParams(params, { replace: true });
  };

  const handleProgramChange = (nextProgram) => {
    setProgramName(nextProgram);
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
    updateProgramParam(nextProgram);
  };

  const handleSourceChange = (nextSource) => {
    setSource(nextSource);
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
  };

  const toggleAppsheet = () => {
    setIncludeAppsheet((prev) => !prev);
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
  };

  const resolvedProgram = useMemo(
    () => (programName !== ALL_PROGRAMS_OPTION ? programName : null),
    [programName]
  );

  const offset = useMemo(
    () => pagination.pageIndex * pagination.pageSize,
    [pagination.pageIndex, pagination.pageSize]
  );

  return {
    programName,
    source,
    includeAppsheet,
    pagination,
    setPagination,
    handleProgramChange,
    handleSourceChange,
    toggleAppsheet,
    resolvedProgram,
    offset,
  };
};
